import { useEffect } from 'react';

import ErrorImg from '@/assets/imgs/unavailableError.webp';
import { AnalyticsOrigination, UnavailableCustomerAnalytics } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import { registerBelenderUnavailable } from '@/services/analytics';

import Auxiliary from '../Auxiliaries/Auxiliary';

interface PersonalFinancesUnavailableProps {
  handleClose: () => void;
  errorType: string;
}

export default function PersonalFinancesUnavailable({ handleClose, errorType }: PersonalFinancesUnavailableProps) {
  const handleErrorScreen = () => {
    switch (errorType) {
      case 'DRF0089':
        return (
          <Auxiliary
            screen="personal-finances-unavailable"
            title="Consulta a Seguridad Social no disponible"
            subtitle="No ha sido posible realizar la consulta con la fecha de nacimiento indicada. Por favor, confírmala con el cliente. Si es correcta, deberás tramitar con Plus o Classic."
            helpText="Llama a tu comercial al <b>912 16 12 12</b> para más información"
            imgSrc={ErrorImg}
            mainButton="Cerrar"
            handleMainButton={() => handleClose()}
          />
        );
      case 'DRF0092':
        return (
          <Auxiliary
            screen="personal-finances-unavailable"
            title="Perfil del cliente no soportado"
            subtitle=" No es posible realizar las consultas necesarias por el perfil del cliente (jubilado/pensionista). Deberás tramitar la solicitud con Plus o Classic."
            helpText="Llama a tu comercial al <b>912 16 12 12</b> para más información"
            imgSrc={ErrorImg}
            mainButton="Cerrar"
            handleMainButton={() => handleClose()}
          />
        );
      default:
        return '';
    }
  };

  useEffect(() => {
    if (errorType === 'DRF0092') {
      registerBelenderUnavailable({ origin: AnalyticsOrigination.App }, UnavailableCustomerAnalytics.Profile);
    } else {
      registerBelenderUnavailable({ origin: AnalyticsOrigination.App }, UnavailableCustomerAnalytics.Unavailable);
    }
  }, []);

  return <>{handleErrorScreen()}</>;
}
